import { ColumnConfig } from "components/Table/types";
import { SearchQueryOrderDirection } from "types/generated";

export const API_KEY_GROUP_MAPPING_COLUMNS_STORAGE_KEY = "apiKeyGroupMappingColumnsConfig";
export const FILTERS_ORDER_SETTINGS_KEY = "apiKeyGroupMappingFiltersOrder";

export const initialSortOption = "name";
export const initialSortDirection = SearchQueryOrderDirection.Desc;

export enum API_KEY_GROUP_MAPPING_COLUMN_ID {
  NAME = "NAME",
  DESCRIPTION = "DESCRIPTION",
  STATUS = "STATUS",
  ACTIONS = "ACTIONS",
}

export const ROW_HEADER_ID = API_KEY_GROUP_MAPPING_COLUMN_ID.NAME;

const MAX_CELL_WIDTH = 600;

const ACTION_CELL_CONFIG: ColumnConfig = {
  [API_KEY_GROUP_MAPPING_COLUMN_ID.ACTIONS]: {
    title: "Group actions",
    noHeader: true,
    static: true,
    maxWidth: 60,
    minWidth: 60,
    width: 60,
    sticky: true,
    resizable: false,
  },
};

const BASE_CONFIG: ColumnConfig = {
  [API_KEY_GROUP_MAPPING_COLUMN_ID.NAME]: {
    title: "Name",
    minWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    static: true,
    resizable: false,
  },
};

export const SIMPLE_COLUMN_CONFIG: ColumnConfig = {
  ...BASE_CONFIG,
  ...ACTION_CELL_CONFIG,
};

export const EXTENDED_COLUMN_CONFIG: ColumnConfig = {
  ...BASE_CONFIG,

  [API_KEY_GROUP_MAPPING_COLUMN_ID.DESCRIPTION]: {
    title: "Description",
    minWidth: 130,
    maxWidth: MAX_CELL_WIDTH,
    resizable: false,
    static: true,
  },
  [API_KEY_GROUP_MAPPING_COLUMN_ID.STATUS]: {
    title: "Status",
    minWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    static: true,
    resizable: false,
  },
  ...ACTION_CELL_CONFIG,
};

export const SORT_CONFIG: Record<string, string> = {
  [API_KEY_GROUP_MAPPING_COLUMN_ID.NAME]: "name",
  [API_KEY_GROUP_MAPPING_COLUMN_ID.STATUS]: "status",
};
